import { DEFAULT_ERROR_MESSAGE } from "constants/defaults";

export const handleResponseError = (error) =>
  error?.response?.data?.errors?.[0]?.detail ||
  error?.message ||
  DEFAULT_ERROR_MESSAGE;
